<app-page-header [title]="'My Tasks'" [subtitle]="'Overview of the tasks in your responsibility'"></app-page-header>
<div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
    <p-table
            [value]="this.tasks"
            [paginator]="true"
            [rows]="10"
            [loading]="this.loading"
            [rowsPerPageOptions]="[5, 10, 20]"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>Sample name</th>
                <th>Task type</th>
                <th>Latest comment</th>
                <th>Last activity</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-task>
            <tr>
                <td>{{ task.sampleName }}</td>
                <td>
                    <p-tag
                            [value]="task.type | enumLabel"
                            [severity]="task.type | taskTypeSeverity"
                    ></p-tag>
                </td>
                <td>{{ task.latestComment }}</td>
                <td>{{ task.sampleLastActivity | formatDateTime }}</td>
                <td>
                    <div class="flex justify-end">
                        <p-button
                                label="View Sample"
                                icon="pi pi-eye"
                                [routerLink]="['/samples/sample', task.sampleId]"
                                text></p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<div class="mb-6">
    <div class="mb-2">
        <h2 class="text-2xl text-gray-800 dark:text-gray-100 font-semibold mb-1">The Sample process flow</h2>
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">The diagram below shows the process flow of a sample in
            the
            system. Samples with no valid vehicle model are archived automatically
        </p>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-md">
        <app-sample-process></app-sample-process>
    </div>
</div>